import { Box, Text } from '@highlight-run/ui/components'
import React from 'react'

const PerformancePage = () => {
	return (
		<Box width="full" height="full" p="16" display="flex" alignItems="center" justifyContent="center">
			<Text color="secondaryContentText">
				Session performance charts are disabled in this build.
			</Text>
		</Box>
	)
}

export default PerformancePage
